import createTransition from 'shared-tokens/utils/createTransition';

export const mainCls =  `csa__tooltip`;
export const arrowSizes = {
  long: 7,
  short: 6,
};
export const defaultBg = '#39434e';

export default {
  [`${mainCls}__trigger`]: {
    display: 'block',
    // '& > *': {
    //   pointerEvents: 'none',
    // },
    '@media (hover: hover)': {
      cursor: 'pointer',
    },
  },
  [`${mainCls}__baloon`]: {
    display: 'block',
    position: 'absolute',
    opacity: 0,
    borderRadius: 4,
    pointerEvents: 'none',
    transition: createTransition(['opacity']),
    background: 'var(--toolTipBg)',
    '&.revealed': {
      opacity: 1,
      pointerEvents: 'all',
    },
    '&.hidden': {
      opacity: 0,
    },
  },
  [`${mainCls}__baloon--top`]: {
    top: -7,
    left: '50%',
    transform: 'translate3d(-50%, -100%, 0)',
    '&:before': {
      position: 'absolute',
      bottom: arrowSizes.long * -1,
      left: '50%',
      marginLeft: arrowSizes.short * -1,
      content: '""',
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: `${arrowSizes.long}px ${arrowSizes.short}px 0 ${arrowSizes.short}px`,
      borderColor: 'var(--toolTipBg) transparent transparent transparent',
    },
  },
  [`${mainCls}__baloon--right`]: {
    top: '50%',
    transform: 'translate3d(4px, -50%, 0)',
    '&:before': {
      position: 'absolute',
      left: arrowSizes.long * -1,
      top: '50%',
      marginTop: arrowSizes.short * -1,
      content: '""',
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: `${arrowSizes.short}px ${arrowSizes.long}px ${arrowSizes.short}px 0`,
      borderColor: 'transparent var(--toolTipBg) transparent transparent',
    },
  },
  [`${mainCls}__baloon--bottom`]: {
    left: '50%',
    transform: 'translate3d(-50%, 0, 0)',
    '&:before': {
      position: 'absolute',
      top: arrowSizes.long * -1,
      left: '50%',
      marginLeft: arrowSizes.short * -1,
      content: '""',
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: `0 ${arrowSizes.short}px ${arrowSizes.long}px ${arrowSizes.short}px`,
      borderColor: 'transparent transparent var(--toolTipBg) transparent',
    },
  },
  [`${mainCls}__baloon--left`]: {
    top: '50%',
    left: -10,
    transform: 'translate3d(-100%, -50%, 0)',
    '&:before': {
      position: 'absolute',
      right: (arrowSizes.long - 1) * -1,
      top: '50%',
      marginTop: arrowSizes.short * -1,
      content: '""',
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: `${arrowSizes.short}px 0 ${arrowSizes.short}px ${arrowSizes.long}px`,
      borderColor: 'transparent transparent transparent var(--toolTipBg)',
    },
  },
};
